import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import ListFromTable from 'components/common/ListFromTable'
import {
  translationsLogbookEventFetchTableData,
  translationsLogbookEventClearStateList,
} from 'reducers/translations/logbookEvent/reducer'
import * as ROUTE from 'constants/appRouting'
import ActionCollection from 'types/table/ActionCollection'
import Action from 'types/table/Action'
import UrlHelper from 'helpers/url'
import ColumnCollection from 'types/table/ColumnCollection'
import Column from 'types/table/Column'
import DateColumn from 'types/table/DateColumn'
import Sort from 'lib/psfs/Sort'
import messages from './translate'

class LogbookEventList extends ListFromTable {
  constructor(props) {
    super(props)
    this.getTableData = props.translationsLogbookEventFetchTableData
    this.clearReducerState = props.translationsLogbookEventClearStateList
    this.asyncData = true
    this.loadingData = true
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (this.props.tableData !== nextProps.tableData) {
      this.loadingData = false
    }

    return super.shouldComponentUpdate(nextProps, nextState, nextContext)
  }

  getTableProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.logbookEventList),
      showFilterBar: true,
      sorting: true,
      paging: true,
      searching: true,
      creating: true,
    }
  }

  getColumns() {
    const {
      intl: { formatMessage },
    } = this.props
    const columns = new ColumnCollection()

    columns.add(new Column('id', 'ID', { sorting: true }))
    columns.add(
      new Column('title', formatMessage(messages.title), {
        sorting: true,
        defaultSort: true,
        defaultSortOrder: Sort.ASC,
      }),
    )
    columns.add(
      new DateColumn('dateUpdated', formatMessage(messages.dateUpdated), {
        sorting: true,
      }),
    )

    return columns
  }

  getActions() {
    const {
      intl: { formatMessage },
      history,
    } = this.props
    const actions = new ActionCollection()

    actions.add(
      new Action('edit', formatMessage(messages.edit), row => {
        history.push(
          UrlHelper.create(ROUTE.TRANSLATIONS_LOGBOOK_EVENT_EDIT, {
            id: row.id,
          }),
        )
      }),
    )

    return actions
  }
}

export default connect(
  state => ({
    tableData: state.getIn(['logbookEventTranslations', 'tableData']),
  }),
  {
    translationsLogbookEventFetchTableData,
    translationsLogbookEventClearStateList,
  },
)(injectIntl(LogbookEventList))
